import { FC, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import useTranslate from "hooks/useTranslate";
import LoyaltyRewardMiniCard from "components/molecules/LoyaltyRewardMiniCard";
import { LoyaltyRewardMiniCardPropsWithId } from "components/molecules/LoyaltyRewardMiniCard/types";
import LoyaltyTooltip from "components/atoms/LoyaltyTooltip";
import { LISTS_REWARDS } from "./constants";
import "./styles.sass";
import { LoyaltyListRewardsPlug } from "../../molecules/LoyaltyListRewardsPlug";

type LoyaltyListRewardsRedesignProps = {
  cashback: LoyaltyRewardMiniCardPropsWithId[];
  freeSpins: LoyaltyRewardMiniCardPropsWithId[];
  nominals: LoyaltyRewardMiniCardPropsWithId[];
  isLoading: boolean;
};

const LoyaltyListRewardsRedesign: FC<LoyaltyListRewardsRedesignProps> = ({
  isLoading,
  ...rewards
}) => {
  const t = useTranslate();
  const lists = useMemo(() => LISTS_REWARDS(rewards), [rewards]);

  return (
    <div className="LoyaltyListRewardsRedesign">
      <h1 className="LoyaltyListRewardsRedesign__mainTitle">
        {t("loyalty.redesign.1.tab.1.available-rewards")}
      </h1>
      <p className="LoyaltyListRewardsRedesign__subtitle">
        {t("loyalty.redesign.1.tab.1.available-rewards.description")}
      </p>
      <div className="LoyaltyListRewardsRedesign__lists">
        {lists.map(({ key, title, list, tooltip }) => (
          <div className="LoyaltyListRewardsRedesign__item" key={key}>
            <div className="LoyaltyListRewardsRedesign__itemHeader">
              <h3 className="LoyaltyListRewardsRedesign__title">{t(title)}</h3>
              <LoyaltyTooltip text={tooltip} />
            </div>

            {/* eslint-disable-next-line no-nested-ternary */}
            {list.length !== 0 ? (
              <Swiper
                spaceBetween={16}
                slidesPerView="auto"
                freeMode
                init={false}
                className="LoyaltyListRewardsRedesign__swiper"
                grabCursor
              >
                {list?.map((card) => (
                  <SwiperSlide
                    key={card.id}
                    className="LoyaltyListRewardsRedesign__slide"
                  >
                    <LoyaltyRewardMiniCard key={card.id} {...card} />
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : !isLoading ? (
              <LoyaltyListRewardsPlug />
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoyaltyListRewardsRedesign;
